<div class="bi-reports">
  <iframe width="1140" height="541.25"
          [src]="sanitizeUrl()"
          frameborder="0"
          allowFullScreen="true">
  </iframe>
</div>
